import { slideup, slidedown } from "./slide";

// eslint-disable-next-line no-unused-vars
import { node, domRenderer } from "venuescanner-js/tools/jsx";

const toElements = (html) => {
  if (typeof window === "undefined") return [];
  if (html.match(/^<[^>^ ]*>$/))
    return [document.createElement(html.replace(/^</, "").replace(/>$/, ""))];
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  return [].slice.call(tmp.children);
};
const toElementList = (element) => {
  if (typeof window === "undefined" || !element) return [];
  return typeof element === "string"
    ? element.match(/</)
      ? toElements(element)
      : [].slice.call(document.querySelectorAll(element))
    : element.element
    ? element.element
    : element instanceof Array
    ? element
    : [element];
};
export const $ = (element) => {
  if (typeof window === "undefined") return null;
  return {
    isElemental: true,
    calledString: typeof element === "string" ? element : "",
    element: toElementList(element),
    classes: function (e) {
      return e.classList;
    },
    slideUp: function () {
      slideup(this.element);
      return this;
    },
    slideDown: function () {
      slidedown(this.element);
      return this;
    },
    toggleClass: function (className, on) {
      if (typeof on === "undefined") {
        if (this.hasClass(className)) {
          this.removeClass(className);
        } else {
          this.addClass(className);
        }
      } else if (on) {
        this.addClass(className);
      } else {
        this.removeClass(className);
      }
      return this;
    },
    addClass: function (className) {
      let classNames = className.split(" ");
      this.element.forEach((e) => {
        classNames.forEach((cn) => {
          if (cn) e.classList.add(cn);
        });
      });
      return this;
    },
    removeClass: function (className) {
      let classNames = className.split(" ");
      this.element.forEach((e) => {
        classNames.forEach((cn) => {
          if (cn) e.classList.remove(cn);
        });
      });
      return this;
    },
    empty: function () {
      this.element.forEach((e) => {
        e.innerHTML = "";
      });
      return this;
    },
    toElements,
    cleanElements: function (elements) {
      let parsedElements = [];
      if (typeof elements === "string") return this.toElements(elements);
      if (!(elements instanceof Array)) {
        if (elements.element) return [...elements.element];
        parsedElements = [elements];
      } else {
        parsedElements = elements.map((e) => {
          if (e.element) return [...e.element];
          return e;
        });
      }
      const arrays = [];
      parsedElements = parsedElements.filter((e) => {
        if (e instanceof Array) {
          arrays.push(e);
          return false;
        }
        return true;
      });
      arrays.forEach((a) => {
        while (a.length) {
          parsedElements.push(a.pop());
        }
      });
      const opElements = parsedElements.map((e) => {
        if (typeof e.render === "function") {
          const newElements = e.render(domRenderer);
          return newElements;
        } else {
          return e;
        }
      });
      // console.log(opElements)
      return opElements.flat().filter((i) => i);
    },
    trigger: function (eventName) {
      const event = new Event(eventName);
      this.element.forEach((element) => {
        if (element.trigger) {
          element.trigger(event);
        } else {
          element.dispatchEvent(event);
        }
      });
    },
    prepend: function (element) {
      if (!element || !this.element.length) return this;
      const toPrepend = this.cleanElements(element);
      try {
        toPrepend.forEach((e) => {
          this.element[0].prepend(e);
        });
      } catch (e) {
        // console.error(e)
      }
      return this;
    },
    append: function (element) {
      if (!element || !this.element.length) return this;
      // if (element.get) console.log(element.get(),toAppend)
      // console.log(this.element)
      try {
        const toAppend = this.cleanElements(element);
        // if (!this.element[0] || (!this.element[0].appendChild && !this.element[0].append)) console.log(this.element)
        // console.log(toAppend)
        toAppend.forEach((e) => {
          if (this.element[0].appendChild) {
            this.element[0].appendChild(e);
          } else {
            this.element[0].append(e);
          }
        });
      } catch (e) {
        console.error(e);
      }
      return this;
    },
    bind: function (event, callback) {
      const events = event.split(" ");
      this.element.forEach((e) => {
        events.forEach((ev) => {
          if (e.attachEvent) {
            e.attachEvent(ev, callback);
          } else {
            e.addEventListener(ev, callback);
          }
        });
      });
      return this;
    },
    unbind: function (event, callback) {
      const events = event.split(" ");
      this.element.forEach((e) => {
        events.forEach((ev) => {
          if (e.attachEvent) {
            e.detachEvent(ev, callback);
          } else {
            e.removeEventListener(ev, callback);
          }
        });
      });
      return this;
    },
    click: function (callback) {
      return this.bind("click", callback);
    },
    change: function (callback) {
      return this.bind("change", callback);
    },
    hasClass: function (className) {
      const classes = this.classes(this.element[0]);
      return classes.contains(className);
    },
    parent: function (selector) {
      if (!selector) return $(this.element[0].parentElement);
      let parent = this.element[0].parentElement;
      if (parent.matches(selector)) return parent;
      while (
        !parent.matches(selector) &&
        this.element[0].parentElement !== document.body
      ) {
        parent = parent.parentElement;
      }
      return $(parent);
    },
    children: function () {
      return [...this.element.map((el) => [...el.children])].flat();
    },
    forEach: function (method) {
      this.element.forEach(method);
    },
    each: function (method) {
      this.element.forEach(method);
    },
    parents: function (selector) {
      let found = [];
      let parent = this.element[0].parentElement;
      if (!parent) return found;
      if (parent.matches(selector)) found.push(parent);
      while (parent.parentElement && parent.parentElement !== document.body) {
        parent = parent.parentElement;
        if (parent.matches(selector)) found.push(parent);
      }
      return $(found);
    },
    siblings: function () {
      const parents = this.element
        .map((el) => el.parentElement)
        .filter((e) => e);
      const children = [...parents.map((el) => [...el.children])].flat();
      return $(children.filter((kid) => !this.element.includes(kid)));
    },
    remove: function () {
      while (this.element.length) {
        const e = this.element.pop();
        e.parentElement.removeChild(e);
      }
      return this;
    },
    find: function (query) {
      return this.element[0]
        ? $([].slice.call(this.element[0].querySelectorAll(`:scope ${query}`)))
        : $([]);
    },
    attr: function (name, value) {
      if (typeof value === "undefined")
        return this.element[0].getAttribute(name);
      if (typeof value === "string") {
        this.element.forEach((e) => {
          e.setAttribute(name, value);
        });
      } else {
        this.element.forEach((e) => {
          e[name] = value;
        });
      }
      return this;
    },
    prop: function (name, value) {
      if (typeof value === "undefined") return this.element[0][name];
      this.element.forEach((e) => {
        e[name] = value;
      });
      return this;
    },
    offset: function () {
      if (this.element.length === 0) return;
      return this.element[0].getBoundingClientRect();
    },
    width: function () {
      if (this.element.length === 0) return;
      return this.element[0].clientWidth;
    },
    height: function () {
      if (this.element.length === 0) return;
      return this.element[0].clientHeight;
    },
    css: function (styles) {
      if (typeof styles === "string") {
        if (this.element.length === 0) return;
        return this.element[0].style[styles];
      } else {
        this.element.forEach((e) => {
          const keys = Object.keys(styles);
          keys.forEach((k) => {
            e.style[k] = styles[k];
          });
        });
        return this;
      }
    },
    html: function (html = false) {
      if (html === false && this.element.length) {
        return this.element[0].innerHTML;
      } else {
        this.element.forEach((e) => {
          if (typeof html !== "string") {
            this.empty().append(html);
          } else {
            e.innerHTML = html;
          }
        });
        return this;
      }
    },
    text: function (text = false) {
      if (text === false && this.element.length) {
        return this.element[0].innerText;
      } else {
        this.element.forEach((e) => {
          if (text.element) {
            this.empty().append(text);
          } else {
            e.innerText = text;
          }
        });
        return this;
      }
    },
    insertBefore: function (el) {
      if (this.element.length) {
        if (this.element[0].parentElement) {
          this.element[0].parentElement.insertBefore(el, this.element[0]);
        }
      }
      return this;
    },
    replaceWith: function (el) {
      if (this.element.length) {
        if (this.element[0].parentElement) {
          this.element[0].parentElement.insertBefore(el, this.element[0]);
          this.remove();
        }
      }
      return $(el);
    },
    get: function (i) {
      if (typeof i === "undefined") return this.element;
      return this.element[i];
    },
    last: function () {
      if (!this.element.length) return null;
      return $(this.element[this.element.length - 1]);
    },
    toggle: function (on) {
      this.css({ display: on ? "initial" : "none" });
      return this;
    },
    hide: function () {
      this.css({ display: "none" });
      return this;
    },
    show: function () {
      this.css({ display: "initial" });
      return this;
    },
    val: function (value) {
      if (typeof value === "undefined") {
        if (this.element.length === 1) {
          let element = this.element[0];
          switch (element.tagName.toLowerCase()) {
            case "select":
              let options = $(element).find("option");
              options.forEach((option) => {
                if (option.selected) return option.value;
              });
              break;
            case "input":
              switch (element.type) {
                case "checkbox":
                  if (element.checked) return element.value;
                  break;
                default:
                  return element.value;
              }
              break;
            default:
              break;
          }
        }
        return null;
      } else {
        this.element.forEach((e) => {
          switch (e.tagName.toLowerCase()) {
            case "select":
              let options = $(e).find("option");
              options.forEach((option) => {
                option.selected = option.value == value;
                // if (option.selected) return option.value
              });
              break;
            case "input":
              switch (e.type) {
                case "checkbox":
                  e.checked = e.value == value;
                  break;
                default:
                  e.value = value;
              }
              break;
            default:
              break;
          }
        });
      }
    },
    vals: function () {
      let values = [];
      this.element.forEach((e) => {
        let val = $(e).val();
        if (val !== null) values.push(val);
      });
      return values;
    },
  };
};
export const e = (type) => {
  if (typeof window === "undefined") return null;
  return $(document.createElement(type));
};
export const getScript = function (url, onload) {
  if (typeof window === "undefined") return;
  const script = document.createElement("script");
  // script.setAttribute('type', 'javascript/text')
  script.setAttribute("src", url);
  script.addEventListener("load", onload);
  if (document.head.appendChild) {
    document.head.appendChild(script);
  } else if (document.head.append) {
    document.head.append(script);
  }
};
let pageLoadInterval = null;
const pageLoadCallbacks = [];
export const pageLoaded = (callback) => {
  if (typeof window === "undefined") return callback();
  if (document.readyState === "complete") {
    callback();
  } else {
    pageLoadCallbacks.push(callback);
    if (!pageLoadInterval) {
      pageLoadInterval = setInterval(function () {
        if (document.readyState === "complete") {
          clearInterval(pageLoadInterval);
          while (pageLoadCallbacks.length) {
            const cb = pageLoadCallbacks.pop();
            try {
              cb();
            } catch (e) {}
          }
        }
      }, 100);
    }
  }
};
// if (!window) {
// } else {
//   window.elemental = $
// }
